(function () {
  'use strict';

 
  function initSticky(root) {
    var aside = root.querySelector('[data-bap-side]');
    if (!aside || aside.classList.contains('bap-side--static')) return;
    var grid = aside.closest('.bap-grid');
    if (!grid) return;

    var offset = parseInt(aside.getAttribute('data-offset'), 10);
    if (isNaN(offset)) offset = 100;
    var breakpoint = window.matchMedia('(max-width: 989px)');
    var naturalLeft = 0;
    var naturalWidth = 0;
    var cachedSideHeight = 0;
    var cachedGridHeight = 0;
    var active = false;
    var ticking = false;
    var lastY = null; // last translateY actually written, to skip no-op writes

    function clearInline() {
      aside.style.position = '';
      aside.style.top = '';
      aside.style.left = '';
      aside.style.width = '';
      aside.style.transform = '';
      lastY = null;
    }

    // Re-measures the sidebar's column position/width. This briefly clears
    // its positioning to get a true "natural flow" measurement, then puts it
    // straight back - only acceptable because it's rare: a real window
    // resize, not something that fires repeatedly while scrolling.
    function remeasureGeometry() {
      var was = active;
      if (was) clearInline();
      var r = aside.getBoundingClientRect();
      var gridBox = grid.getBoundingClientRect();
      naturalLeft = r.left - gridBox.left;
      naturalWidth = r.width;
      active = false; // force update() to reapply position styles with the fresh measurement
      if (was) update();
    }

    // Refreshes the cached heights used for the "release at the bottom" clamp.
    // Unlike remeasureGeometry, this never touches the sidebar's positioning -
    // offsetHeight is readable directly regardless of position mode - so it's
    // safe to call often, including every time an image in the article
    // finishes loading (that's exactly what actually changes the article's
    // height while scrolling, and it can happen many times in quick
    // succession, which is why this path in particular must never flash).
    function refreshHeights() {
      cachedSideHeight = aside.offsetHeight;
      cachedGridHeight = grid.offsetHeight;
    }

    function update() {
      if (breakpoint.matches) {
        if (active) { clearInline(); active = false; }
        return;
      }
      if (!active) {
        aside.style.position = 'absolute';
        aside.style.left = naturalLeft + 'px';
        aside.style.width = naturalWidth + 'px';
        aside.style.top = '0px'; // set once; all per-frame movement below uses transform instead,
        active = true;           // since animating "top" forces a full layout recalculation on every
      }                          // frame, while "transform" is handled by the compositor alone and is
                                  // far cheaper - important on a real page with much more on it than a
                                  // test page, where forcing layout 60 times a second can visibly drop
                                  // frames and make the sidebar appear to stutter/shake while scrolling.

      // The one measurement that must be fresh every single frame, since it
      // depends on the current scroll position.
      var gridBox = grid.getBoundingClientRect();
      var scrollY = window.scrollY || window.pageYOffset;
      var gridTopDoc = scrollY + gridBox.top; // the grid's top, in document coordinates (scroll-invariant)

      // Where the sidebar's top would sit in the viewport while "stuck". For
      // a sidebar taller than the window, this can go negative so its
      // bottom edge stays reachable instead of running off the bottom of
      // the screen forever.
      var desiredViewportTop = Math.min(offset, window.innerHeight - cachedSideHeight - 24);

      var y = desiredViewportTop + scrollY - gridTopDoc;
      y = Math.max(0, Math.min(y, Math.max(0, cachedGridHeight - cachedSideHeight)));

      if (lastY !== null && Math.abs(y - lastY) < 0.5) return; // avoid a redundant, no-op style write
      lastY = y;
      aside.style.transform = 'translateY(' + y + 'px)';
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { update(); ticking = false; });
    }
    function onResize() {
      remeasureGeometry();
      refreshHeights();
    }
    function onArticleResize() {
      refreshHeights();
    }

    grid.style.position = grid.style.position || 'relative';
    remeasureGeometry();
    refreshHeights();
    update();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onResize);
    window.addEventListener('load', onResize);
    var article = grid.querySelector('.bap-article');
    if ('ResizeObserver' in window && article) {
      var ro = new ResizeObserver(onArticleResize);
      ro.observe(article);
      root.__bapCleanups.push(function () { ro.disconnect(); });
    }
    root.__bapCleanups.push(function () {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onResize);
      window.removeEventListener('load', onResize);
      clearInline();
    });
  }

  /* ---------- Table of contents ----------
     Built from the article's own H2 (and optionally H3) headings, since
     Shopify's rich-text editor doesn't give headings ids to link to.
     Placed right before a heading whose text is exactly "Introduction"
     (case-insensitive) if the article has one; otherwise right before the
     first heading, which is the conventional spot for a TOC. */
  function slugify(text, used) {
    var base = text
      .toLowerCase()
      .replace(/['’]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '') || 'section';
    var slug = base;
    var n = 2;
    while (used[slug]) {
      slug = base + '-' + n;
      n++;
    }
    used[slug] = true;
    return slug;
  }

  // Opens the matching FAQ question whenever the page's URL fragment points
  // at one - not just when a TOC link inside this page is clicked, but also
  // when someone opens a link that already has "#faq-2" in it (a shared
  // link, a search result, browser back/forward), since those never fire a
  // click on anything inside the page.
  function openFaqFromHash() {
    var hash = window.location.hash;
    if (!/^#faq-\d+$/.test(hash)) return;
    var target = document.getElementById(hash.slice(1));
    if (target && target.tagName === 'DETAILS') target.open = true;
  }
  function initFaqDeepLinks() {
    openFaqFromHash();
    window.addEventListener('hashchange', openFaqFromHash);
  }

  function initToc(root) {
    var nav = root.querySelector('[data-bap-toc]');
    var content = root.querySelector('.bap-content');
    if (!nav || !content) return;

    var includeH3 = nav.getAttribute('data-toc-h3') === 'true';
    var selector = includeH3 ? 'h2, h3' : 'h2';
    var headings = Array.prototype.slice.call(content.querySelectorAll(selector)).filter(function (h) {
      return (h.textContent || '').trim() !== '';
    });
    var hasFaq = !!root.querySelector('[data-bap-toc-include]');
    if (headings.length + (hasFaq ? 1 : 0) < 2) { nav.remove(); return; }

    var used = {};
    var list = document.createElement('ul');
    list.className = 'bap-toc__list';
    var currentSubList = null;

    headings.forEach(function (h) {
      if (!h.id) h.id = slugify(h.textContent || '', used);
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = h.textContent;
      li.appendChild(a);

      if (h.tagName === 'H2') {
        list.appendChild(li);
        currentSubList = null;
      } else {
        // H3 nests under the most recent H2; if a H3 appears before any H2, treat it as top-level
        var parentLi = list.lastElementChild;
        if (!parentLi) {
          list.appendChild(li);
          return;
        }
        if (!currentSubList) {
          currentSubList = document.createElement('ul');
          parentLi.appendChild(currentSubList);
        }
        currentSubList.appendChild(li);
      }
    });

    var faqSection = root.querySelector('[data-bap-toc-include]');
    if (faqSection) {
      var faqLi = document.createElement('li');
      var faqA = document.createElement('a');
      faqA.href = '#' + (faqSection.id || 'faq');
      faqA.textContent = faqSection.getAttribute('data-toc-label') || 'FAQs';
      faqLi.appendChild(faqA);
      if (includeH3) {
        var questions = Array.prototype.slice.call(faqSection.querySelectorAll('.bap-faq__q'));
        if (questions.length) {
          var faqSubList = document.createElement('ul');
          questions.forEach(function (q) {
            var details = q.closest('details');
            if (!details || !details.id) return;
            var qLi = document.createElement('li');
            var qA = document.createElement('a');
            qA.href = '#' + details.id;
            var qSpan = q.querySelector('span');
            qA.textContent = (qSpan ? qSpan.textContent : q.textContent) || '';
            qLi.appendChild(qA);
            faqSubList.appendChild(qLi);
          });
          faqLi.appendChild(faqSubList);
        }
      }
      list.appendChild(faqLi);
    }

    var title = document.createElement('p');
    title.className = 'bap-toc__title';
    title.textContent = nav.getAttribute('data-toc-heading') || 'Table of Contents';
    nav.appendChild(title);
    nav.appendChild(list);

    // find a heading literally called "Introduction"; otherwise use the first heading
    var target = headings.find(function (h) {
      return (h.textContent || '').trim().toLowerCase() === 'introduction';
    }) || headings[0];
    target.parentNode.insertBefore(nav, target);
  }

  /* ---------- Auto alt-text for article body images ----------
     Images typed straight into the article (via Shopify's rich-text editor)
     aren't touched by the Liquid alt-text logic used elsewhere on this page,
     since Liquid never sees inside {{ article.content }} image by image.
     If an <img> in the article has no alt text, this derives one from its
     file name, same rule as the Liquid snippet: "hand-bag_tote.jpg" -> "Hand bag tote". */
  function deriveAltFromSrc(src) {
    try {
      var name = (src.split('/').pop() || '').split('?')[0];
      try { name = decodeURIComponent(name); } catch (e) { /* leave as-is if it isn't valid encoding */ }
      name = name.replace(/\.[a-zA-Z0-9]+$/, '');
      name = name.replace(/[-_]+/g, ' ').replace(/\s+/g, ' ').trim();
      if (!name) return '';
      return name.charAt(0).toUpperCase() + name.slice(1);
    } catch (e) {
      return '';
    }
  }
  function initContentAltText(root) {
    var imgs = root.querySelectorAll('.bap-content img');
    imgs.forEach(function (img) {
      var alt = img.getAttribute('alt');
      if (alt === null || alt.trim() === '') {
        var src = img.currentSrc || img.getAttribute('src') || '';
        var derived = deriveAltFromSrc(src);
        if (derived) img.setAttribute('alt', derived);
      }
    });
  }

  /* ---------- Copy link button ---------- */
  function initCopy(root) {
    var btn = root.querySelector('[data-bap-copy]');
    if (!btn) return;
    var tip = root.querySelector('[data-bap-tip]');
    var timer = null;

    function done(ok) {
      if (!tip) return;
      tip.textContent = ok ? 'Link copied' : 'Press Ctrl+C to copy';
      clearTimeout(timer);
      timer = setTimeout(function () { tip.textContent = ''; }, 2200);
    }
    function fallback() {
      var ta = document.createElement('textarea');
      ta.value = window.location.href;
      ta.setAttribute('readonly', '');
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      var ok = false;
      try { ok = document.execCommand('copy'); } catch (e) { ok = false; }
      document.body.removeChild(ta);
      done(ok);
    }

    btn.addEventListener('click', function () {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(window.location.href).then(function () { done(true); }, fallback);
      } else {
        fallback();
      }
    });
  }

  function init(root) {
    if (root.__bapReady) return;
    root.__bapReady = true;
    root.__bapCleanups = [];
    initSticky(root);
    initCopy(root);
    initToc(root);
    initFaqDeepLinks();
    initContentAltText(root);
  }

  function initAll() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-bap]'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* Shopify theme editor re-renders sections live */
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-bap]');
    if (root) init(root);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    var root = e.target.querySelector('[data-bap]');
    if (root && root.__bapCleanups) root.__bapCleanups.forEach(function (fn) { fn(); });
  });
})();